import { withInstall } from '@ll-plus/utils'

import InputNumber from './src/input-number.vue'

export const LlInputNumber = withInstall(InputNumber)
export default LlInputNumber
export * from './src/input-number'

declare module 'vue' {
  export interface GlobalComponents {
    LlInputNumber: typeof InputNumber
  }
}
